/** Formatos compartidos por los informes de Vivienda Gerencia (formato CR). */

/** Monto en colones con miles separados por espacio; "—" si es cero. */
export function fmtMonto(v: number): string {
  if (!v) return '—';
  const neg = v < 0;
  const s = Math.round(Math.abs(v))
    .toLocaleString('es-CR', { maximumFractionDigits: 0 })
    .replace(/,/g, ' ');
  return `${neg ? '-' : ''}₡${s}`;
}

/** Razón num ÷ den como porcentaje con 1 decimal; "—" si falta alguno. */
export function fmtPct(num: number, den: number): string {
  if (!den || !num) return '—';
  return `${((num / den) * 100).toLocaleString('es-CR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`;
}

/** Número entero con miles separados por espacio (formato CR). */
export function fmtNum(v: number): string {
  return Math.round(v).toLocaleString('es-CR').replace(/,/g, ' ');
}

/** Razón como fracción 0–1, o null si falta numerador o denominador. */
export const razon = (num: number, den: number): number | null => (num && den ? num / den : null);

/** Texto para exportaciones: obras excluidas que están presentes en los datos (o null). */
export function describirExcluidas(
  excluidas: Set<string>,
  filas: { worksNo: string }[],
): string | null {
  const presentes = [...new Set(filas.map((f) => f.worksNo))]
    .filter((w) => excluidas.has(w))
    .sort((a, b) => a.localeCompare(b, 'es', { numeric: true }));
  if (presentes.length === 0) return null;
  const MAX = 15;
  const lista = presentes.slice(0, MAX).join(', ');
  return `Obras excluidas (${presentes.length}): ${lista}${presentes.length > MAX ? ` y ${presentes.length - MAX} más` : ''}`;
}

const NOMBRES_MES = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sep',
  'Oct',
  'Nov',
  'Dic',
];

/** Descripción legible del filtro de períodos global (para encabezados de exportación). */
export function describirPeriodo(f: {
  aniosSel?: number[];
  mesesSel?: string[];
  diasSel?: string[];
}): string {
  const partes: string[] = [];
  if (f.aniosSel?.length) partes.push(`Años ${[...f.aniosSel].sort().join(', ')}`);
  if (f.mesesSel?.length) {
    partes.push(
      [...f.mesesSel]
        .sort()
        .map((m) => {
          const [y, mm] = m.split('-').map(Number);
          return `${NOMBRES_MES[(mm ?? 1) - 1]} ${y}`;
        })
        .join(', '),
    );
  }
  if (f.diasSel?.length) partes.push(`${f.diasSel.length} día(s) seleccionados`);
  return partes.length ? partes.join(' · ') : 'Todo el historial';
}
